<template lang="">
<div class="">
    <Card class="p-m-2">
        <template #title> Tüm Yazılar </template>
<template #content>
            <DataTable v-if="DataTable_render" :data="BlogYaziList" :columns="columns" v-on:set-child-data="getDataChild" :editbutton="true" />
        </template>
</Card>

<Dialog v-model:visible="BlogModal" :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '70vw' }"
    :modal="true">
    <template #header>
            <h4>Blog Düzenle</h4>
        </template>

    <div class="formgrid grid">
        <div class="field col-6">
            <label for="Baslik"><b>Başlık</b></label>
            <IconField iconPosition="left">
                <InputIcon class="pi pi-user"> </InputIcon>
                <InputText v-model="Baslik" style="width:100%" />
            </IconField>

        </div>
        <div class="field col-6">
            <label for="YazarAd"><b>Yazar Adı</b></label>
            <IconField iconPosition="left">
                <InputIcon class="pi pi-user"> </InputIcon>
                <InputText v-model="YazarAd" style="width:100%" />
            </IconField>
        </div>
        <div class="field col-2">
            <input class="p-button p-component p-button-sm p-mr-2 p-mb-2 " type="file" @change="customBase64Uploader">
        </div>
        <div class="field col-5"></div>
        <div class="field col-5">
            <Image :v-if="imageIsEmpty" :src="image" alt="Image" preview width="300" />
        </div>
        <div class="field col-12">
            <hr class="solid">
        </div>
        <div class="field col-12 ">
            <Editor v-model="blogText" editorStyle="height: 50vh" />
        </div>

    </div>
    <template #footer>
            <ConfirmDialog></ConfirmDialog>
            <Button label="Sil" icon="pi pi-times" class="p-button-sm p-button-warning" @click="this.BlogSil($event)" />
            <Button label="Tamam" icon="pi pi-check" class="p-button-sm p-button-success" @click="this.handleClick(!v$.$invalid)" autofocus />
            <Button label="Kapat" icon="pi pi-times" class="p-button-sm p-button-danger" @click="this._BlogModal()" />
        </template>
</Dialog>
</div>
</template>

<script>
import DataTable from "../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../services/GlobalServis";
export default {
    data() {
        return {
            DataTable_render: true,
            BlogModal: false,
            BlogYaziList: [],
            imageIsEmpty: true,
            image: require('../../../../assets/genel/not_found_image.jpg'),
            Blog_rowid: null,
            YazarAd: '',
            Baslik: '',
            blogText: '',
            yaratmatarih: '',
            columns: [{
                field: "Baslik",
                header: "Başlık"
            },
            {
                field: "YazarAd",
                header: "Yazar"
            },
            {
                field: "Tarih",
                header: "Tarih"
            },
            ]
        }
    },
    methods: {
        getDataChild(getdata_child) {
            this.BlogModal = !this.BlogModal;
            this.Blog_rowid = getdata_child.data.Blog_rowid;
            let data = {
                Blog_rowid: getdata_child.data.Blog_rowid,
            };

            GlobalServis.GlobalServis("POST", "GetUrunSayi", data).then((res) => {
                if (res.status == 200) {
                    if (res.data.Image === "") { this.image = require('../../../../assets/genel/not_found_image.jpg') }
                    else { this.image = Buffer.from(res.data.Image, 'base64').toString('ascii'); }
                    this.Blog_rowid = res.data.Blog_rowid
                    this.YazarAd = res.data.YazarAd
                    this.Baslik = res.data.Baslik
                    this.blogText = res.data.BlogText
                    this.yaratmatarih = res.data.YaratmaTarih
                    this.imageIsEmpty = false
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });
        },
        InitService() {
            GlobalServis.GlobalServis("GET", "GetUrunSayi", "").then((res) => {
                if (res.status == 200) {
                    this.BlogYaziList = res.data;
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });
        },
        BlogSil(event) {
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Bu yazıyı silmek istediğinizden emin misiniz ?',
                icon: 'pi pi-exclamation-triangle',
                rejectIcon: 'pi pi-times',
                rejectClass: 'p-button-sm',
                acceptIcon: 'pi pi-check',
                acceptClass: 'p-button-outlined p-button-sm',
                accept: () => {
                    let data = {
                        Blog_rowid: this.Blog_rowid,
                    };

                    GlobalServis.GlobalServis("POST", "DeleteBlogYazi", data).then((res) => {
                        if (res.status == 200) {
                            this.$toast.add({
                                severity: "success",
                                summary: "Başarılı",
                                detail: "Kayıt Silindi",
                                life: 3000,
                            });
                            this._BlogModal();
                        } else if (res.response.status === 999) {
                            this.$toast.add({
                                severity: "warn",
                                summary: "Uyarı",
                                detail: res.response.data,
                                life: 3000,
                            });
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Hata",
                                detail: "Hata oldu",
                                life: 3000,
                            });
                        }
                    }).then(() => {
                    });

                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Uyarı', detail: 'İşlem iptal edildi.', life: 3000 });
                }
            });
        },
        _BlogModal() {
            this.BlogModal = !this.BlogModal;
            this._ResetModal();
        },
        _ResetModal() {
            this.imageIsEmpty = true;
            this.image = require('../../../../assets/genel/not_found_image.jpg');
            this.YazarAd = '';
            this.Baslik = '';
            this.blogText = '';
            this.yaratmatarih = ''
        },
        customBase64Uploader(event) {
            this.imageIsEmpty = true;
            const file = event.target.files[0];
            const reader = new FileReader();
            // eslint-disable-next-line 
            let blob = fetch(file).then((r) => r.blob()); //blob:url
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                this.image = reader.result;
                this.imageIsEmpty = false;
            };
        },
    },
    mounted() {
        this.InitService();
    },
    components: {
        DataTable,
    },
}
</script>

<style lang="">

</style>
